import React from "react"
import PropTypes from "prop-types"
import ChartSDG13GhgEmissionsPerVisitKPIMolecule from "views/molecules/canvases/charts/websites/ChartSDG13GhgEmissionsPerVisitKPIMolecule"
import { useAppContext } from "components/AppContext"

const ChartODD13GhgPerVisitOrFallbackMolecule = ({ score, fallback }) => {
  const { score: globalScore } = useAppContext()

  if (score?.should_display_ghg_per_visit_kpi) {
    return (
      <ChartSDG13GhgEmissionsPerVisitKPIMolecule
        ghgEmissionsPerVisit={score?.website_analyse?.ghg_average_visit_CO2}
        trendBadge={globalScore?.trend_badges?.odd13_ghg_average_visit_CO2}
      />
    )
  }

  return fallback
}

ChartODD13GhgPerVisitOrFallbackMolecule.propTypes = {
  score: PropTypes.object.isRequired,
  fallback: PropTypes.node.isRequired,
}

export default ChartODD13GhgPerVisitOrFallbackMolecule
